import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(public snackBar: MatSnackBar) { }

  successMessage(message: string) {
    this.openSnackBar(message, 'success-panel')
  }

  failedMessage(message: string) {
    this.openSnackBar(message, 'error-panel')
  }

  openSnackBar(message: string, panelClass: string, timer?) {
    this.snackBar.open(message, '', {
      duration: timer ? timer : panelClass === 'success-panel' ? 1800 : 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }
}
